/**
 *  AenaTerminalsCategories script file
**/

import Vue from 'vue'
import { mapGetters } from 'vuex'
import { GETTERS } from '@/store'
import { normalizeLowerCase } from '@/utils/matchString'
import setDeviceWidthClass from '@/mixins/setDeviceWidthClass'

export default {
  name: 'app-aenaTerminalsCategories',
  mixins: [setDeviceWidthClass],
  components: {},
  props: {
    category: {
      type: Object
    },
    categories: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      activeCategories: [],
      toggle: false
    }
  },
  created () {
    this.updateSelected()
    this.onCategoryChange()
  },
  destroyed () {
    this.resetCategory()
  },
  computed: {
    ...mapGetters({
      isMobile: GETTERS.GET_IS_MOBILE,
      activeFilterC: GETTERS.GET_ACTIVE_FILTERS,
      airportID: GETTERS.GET_AIRPORT_ID
    }),
    categoriesVisible () {
      let categories = this.categories
      if (!this.isMobile) {
        categories = this.toggle ? categories : categories.slice(0, 6)
      }

      return categories
    },
    categoriesHidden () {
      return this.categories.length - this.categoriesVisible.length
    },
    noDuplicate () {
      if (this.category && this.categoriesVisible.length === 1 && this.category.name === this.categoriesVisible[0].name) {
        this.setCategory(this.categoriesVisible[0])
        return true
      }
    }
  },
  methods: {
    updateSelected () {
      (this.activeFilterC.subcategories || []).forEach(x => {
        const el = this.categories.find(c => c.id === x)
        this.setCategory(el)
      })
    },
    resetCategory () {
      this.activeCategories = []
      this.categories.forEach(element => {
        element.active = false
      })
    },
    setCategory (category) {
      if (!category) {
        this.resetCategory()
      } else {
        Vue.set(category, 'active', !category.active)
        const el = this.activeCategories.includes(category.id)
        if (el) {
          this.activeCategories = this.activeCategories.filter(x => x !== category.id)
        } else {
          this.activeCategories.push(category.id)
        }
      }
    },
    onCategoryChange () {
      let cat = null
      if (this.category) {
        cat = { ...this.category }
      }
      if (cat && cat.subcategories) {
        cat.subcategories = cat.subcategories.map(x => x.id)
      }
      this.$emit('onCategoryChange', {
        data: this.activeCategories.length ? this.activeCategories : cat,
        type: this.activeCategories.length ? 'subcategories' : 'category'
      })
    },
    onChange (category) {
      this.setCategory(category)
      this.onCategoryChange()

      let _category = category
      if (!category) {
        _category = this.category
      }

      const tag = {
        'eventCategory': 'buscador',
        'eventAction': 'categoria',
        'eventLabel': `${normalizeLowerCase(_category.name)}`,
        'language': this.$i18n.locale,
        'airportID': this.airportID
      }
      window.digitalChange('event', tag)
    },
    onToggle () {
      this.toggle = !this.toggle
    },
    isActive (id) {
      return this.activeCategories.includes(id)
    },
    goBack () {
      this.$emit('goBack')
    }
  },
  watch: {
    'activeFilterC.subcategories': {
      handler () {
        this.resetCategory()
        this.updateSelected()
      }
    }
  }
}
